<template>
  <div style="width: 100%;">
    <label v-if="label" :for="id">{{ label }}</label>
    <br v-if="label" />

    <input
      :class="['text-input', 'form-control', { 'is-invalid': !!errorMessage }]"
      :value="modelValue"
      @input="change"
      @click.prevent="click($event)"
      :name="id"
      type="text"
      autocomplete="off"
      :disabled="disabled"
    />
    <transition name="fade">
      <span v-if="errorMessage" class="error">{{ errorMessage }}</span>
    </transition>
  </div>
</template>

<script>
export default {
  name: "ModalTextInput",
  components: {},
  props: {
    id: {
      required: true,
      type: String,
    },
    label: {
      required: false,
      type: String,
    },
    modelValue: {
      required: true,
      type: String,
    },
    errorMessage: {
      required: false,
      type: String,
    },
    disabled: {
      required: false,
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    change($event) {
      this.$emit("update:modelValue", $event.target.value);
    },
    click($event) {
      this.$emit("click", $event);
    },
  },
};
</script>

<style scoped>
.text-input {
  width: calc(100% - 31px);
  border-radius: 5px 0px 0px 5px;
}
.form-control:disabled {
  background-color: #e9ecef;
  opacity: 1;
}

.form-control {
  color: gray;
}
</style>



// WEBPACK FOOTER //
// src/common/components/ModalTextInput.vue